module.exports = __webpack_public_path__ + "static/img/ry1.c46c81e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutLanshu/ry1.jpg
// module id = dthe
// module chunks = 0